export const APP_STATIC = {
  brand_name: 'Shop & Fly',
  app_icon: '/favicon.ico',
  app_logo: '/static/icons/logo.svg',
  phone: '444 03 33',
  email: 'shopandflyiletisim@setur.com.tr',
  meta: {
    title: 'Tatilinizi Shop & Fly Seyahat İle Planlayın - Shop & Fly',
    description:
      'Otel rezervasyonundan uçak biletine, araç kiralamadan gemi turlarına, tatil planınızın her adımında Shop & Fly seyahat yanınızda!',
  },
};
